import GlossaryText, { GlossaryContext } from './GlossaryText';

export { GlossaryContext };
export default GlossaryText;
